import { Address } from '../components/AddressLookup';
import { useEffect, useState } from 'react';
import { BankHolidays } from '../models/APIModels';
import {
  addWorkingDaysFrom,
  populateDisabledDays,
} from './CollectionDateConstraints';
import moment from 'moment/moment';
import { axiosKK } from '../services/networkRequest';

/**
 * @param startDate dates up to and including it are disabled (a delivery follows its collection)
 * @param minWorkingDaysAfterStart instead disable everything before this many working days after startDate
 */
export function useDateDisabler(
  address: Address | null,
  startDate: Date | null,
  minDaysBuffer?: number,
  minWorkingDaysAfterStart?: number,
) {
  const [bankHolidays, setBankHolidays] = useState<BankHolidays>();
  const [disabledDays, setDisabledDays] = useState<any[]>([
    { daysOfWeek: [0, 6] },
  ]);

  // Callers build startDate inline, so depend on its value rather than its identity.
  const startTime = startDate != null ? startDate.getTime() : null;

  useEffect(() => {
    if (bankHolidays) {
      axiosKK
        .get('time')
        .then((response) => {
          return response && response.data && response.data.time
            ? new Date(response.data.time)
            : new Date();
        })
        .catch(() => new Date())
        .then((date) => {
          const earliest =
            startTime == null
              ? null
              : minWorkingDaysAfterStart !== undefined
              ? addWorkingDaysFrom(
                  startTime,
                  minWorkingDaysAfterStart,
                  bankHolidays,
                  address,
                )
              : moment(startTime).add(1, 'days').toDate();

          setDisabledDays(
            populateDisabledDays(
              bankHolidays,
              address,
              date,
              earliest != null ? [{ before: earliest }] : [],
              minDaysBuffer,
            ),
          );
        });
    } else {
      fetch('https://www.gov.uk/bank-holidays.json')
        .then((response) => response.json())
        .then((data) => setBankHolidays(data))
        .catch(console.log);
    }
    // eslint-disable-next-line
  }, [address, bankHolidays, minDaysBuffer, startTime, minWorkingDaysAfterStart]);

  return disabledDays;
}
